module.exports = __webpack_public_path__ + "static/Final2-785207a57e8761c3e33b8f2f75a2ca6c.mp4";